import './PageContainer.scoped.scss'
import useAct from '../useAct'
import EditableName from 'Shared/components/EditableName/EditableName'
import { ManageMenuItem } from 'Shared/components/ManageMenu';
import ManageMenuComponent from 'Shared/components/ManageMenu/ManageMenuComponent'
import CopyToClipboard from 'Shared/components/CopyToClipboard'
import ExportConfirmationModal from 'Shared/components/ExportConfirmationModal';
import restClient from 'Shared/hooks/restClient'
import FloatingMenu from 'Shared/components/FloatingMenu/FloatingMenu';
import OverviewSection from './OverviewSection';
import StatsSection from './StatsSection';

const items = [
  { name: 'Status', tag: 'status' },
  { name: 'Analytics', tag: 'analytics' },
]

export default function PageContainer({ dashboardId, dashboardName }) {
  const act = useAct()
  const dashboard = useSel((s) => s.dashboard)

  useEffect(() => {
    if (dashboardId) {
      act.dashboard.load(dashboardId)
      act.dashboard.loadStats(dashboardId)
    }
  }, [dashboardId])

  const [exportPassword, setExportPassword] = useState(null)
  const doExport = () => {
    restClient.post(`/api/dashboards/${dashboardId}/export`).then((response) => {
      setExportPassword(response.data.password)
    })
  }

  const menuItems: ManageMenuItem[] = useMemo(() => [
    {
      title: (
        <span className="flex items-center">Edit</span>
      ),
      onClick: () => {
        window.location.href = `/admin/dashboards/${dashboardId}/build`;
      },
    },
    {
      title: (
        <span className="flex items-center">Export results</span>
      ),
      onClick: () => doExport('default'),
    },
  ], [dashboardId]);

  return (
  <>

    <div className="header dashboard">
      <a className='back' href="/admin/dashboards"></a>
      <div className="name-container">
        <EditableName
          modelName="dashboard"
          endpoint={`/api/dashboards/${dashboardId}`}
          noMarginBottom={true}
        />
        <div className="actions">
          <a className='button secondary' target='_blank' href={`${dashboard?.publicUrl}`} rel="noreferrer">View</a>
          <ManageMenuComponent
            items={menuItems}
            components={[]}
            buttonType='primary'
          />
        </div>

    <div className='url'>
     <span>{dashboard?.publicUrl}</span>
     <div className='copier'><CopyToClipboard text="Copy" url={dashboard?.publicUrl} /></div>
    </div>

      </div>
    </div>

    <div className='dashboard-overview margin-top double'>
      <div className="left">
        <FloatingMenu items={items} />
      </div>
      <div className='right'>
        <OverviewSection />
        <StatsSection />
      </div>
    </div>

    <ExportConfirmationModal
      exportPassword={exportPassword}
      setExportPassword={setExportPassword}
      entityName="dashboard" />
    </>
  )
}